/**
 * WebSocket类 - 包含[ 断线重连, 心跳检测, 粘包抑制 ]
 * @param __TF [true自动启动，默认false] 或 {
 *                                             host:str ws://地址:端口,
 *                                             name:str 客户端名称,
 *                                             onopen:fun 握手成功后触发,
 *                                             onclose:fun 关闭会话后触发,
 *                                             onmessage:fun 接收信息是触发,
 *                                             autoLink:bool 是否自动重连
 *                                             auto:bool 是否自动启动
 *                                            }
 * @returns {SKT}
 * @constructor {
 *                  onopen:fun 握手成功后触发,
 *                  onclose:fun 关闭会话后触发,
 *                  onmessage:fun 接收信息是触发,
 *                  start:fun 开始握手,
 *                  send:fun(str) 发送信息,
 *                  close|stop:fun 停止方法,
 *                  host:str ws://地址:端口,
 *                  name:str 客户端名称,
 *                  autoLink:bool 是否自动重连，默认true
 *                 }
 */

const WSK = (__TF) => {
  this.host = 'ws://127.0.0.1'; this.socket = null; this.name = '';
  this.autoLink = !0; // --允许断线重连
  this.onopen = (s) => { if (typeof s === 'function') this.onopen = s; };
  this.onmessage = (msg) => { if (typeof msg === 'function') { this.onmessage = msg; } };
  this.onclose = (s) => { if (typeof s === 'function') { this.onclose = s; } };

  /**
   * 开启一个握手会话
   */
  this.start = () => {
    try {
      const that = this;
      this.socket = new WebSocket(this.host);
      this.socket.onopen = () => {
        that.autoLinkNum = 0;
        clearTimeout(this.autoLinkT);
        that.socket.send(`__reg__:${that.name}`);
        that.Heart();// --定时心跳----
        that.onopen();
      };
      this.socket.onmessage = (e) => {
        if (e.data === '__quit__') {
          that.close(); return !0;
        }
        const s = that.onmessage(e.data);
        if (s === undefined || s === null) return !0;
        that.send(s);
        return true;
      };
      this.socket.onclose = () => {
        that.autoLink(); // --握手尝试器
      };
    } catch (ex) {
      this.autoLink();
    }
    return true;
  };

  /**
   * 关闭通讯
   * @type {WSK.stop}
   */
  this.stop = () => {
    clearTimeout(this.autoLinkT);
    this.autoLink = !1; // 告诉系统不用重试了本操作是人工或服务端停止的
    this.temp = []; // 清空排队阵列
    try { this.socket.close(); } catch (ex) {
      // console.log(ex);
    }
  };
  this.close = this.stop;

  /**
   * 发送数据到服务端 引入排队机制规避粘包问题
   * @param msg 要发送的信息
   * @returns {boolean}
   */
  this.send = (msg1) => {
    let msg = msg1;
    if (msg === undefined || msg === null) return !1;
    const that = this;
    try {
      if (typeof msg === 'boolean') msg = msg ? '!0' : '!1';// --布尔类型就转换一下形式
      else msg = JSON.stringify(msg);
    } catch (e) { msg = msg.toString(); }
    this.temp.push(msg);
    if (that.t === undefined) { // --阻止粘包事件策略------------
      this.t = setInterval(() => {
        if (that.socket.bufferedAmount === 0) {
          // --如果缓冲区在忙碌及等定时器下一轮
          if (that.temp.length) {
            try {
              that.socket.send(that.temp[0]);
            } catch (e) {
              // console.log(e);
            }
            that.temp.splice(0, 1);
          } else {
            clearInterval(that.t);
            that.t = undefined;
          }
        }
      }, 5);
    }
    return true;
  };
  this.temp = [];// --排队缓存

  /**
   * 定时器心跳
   * @param T
   * @returns {boolean}
   */
  this.Heart = (T) => {
    const that = this;
    // eslint-disable-next-line no-undef
    if (this.socket.readyState === 2 || this.socket.readyState === 3) return !1;
    // eslint-disable-next-line no-undef
    if (T) that.socket.send('__reg__'); // --心跳
    setTimeout(() => {
      that.Heart(1);// log('心跳')
    }, 5000);
    return true;
  };

  /**
   * 自动重连内置方法
   * @private
   */
  this.autoLinkT = {};// --重试定时器
  this.autoLinkNum = 0;// --重复计数器--
  this.autoLink = () => {
    if (this.autoLink) {
      const that = this;
      this.alTime = this.alTime ? this.alTime : 1000;
      this.autoLinkT = setTimeout(() => {
        that.autoLinkNum += 1;
        if (that.autoLinkNum > 2) {
          that.alTime = 5000;
        }
        if (that.autoLinkNum > 10) {
          // console.log('放弃尝试....');
          that.autoLink = !1;
          that.onclose();
          return !1;
        }
        // console.log(`[${that.autoLinkNum}] 尝试重连...`);
        that.start();
        return true;
      }, this.alTime);
    } else this.onclose();
    return true;
  };
  if (typeof __TF === 'object' && __TF) {
    // --传递参数--赋值
    if (Object.prototype.hasOwnProperty.call(__TF, 'host')) this.host = __TF.host;
    if (Object.prototype.hasOwnProperty.call(__TF, 'name')) this.name = __TF.name;
    if (Object.prototype.hasOwnProperty.call(__TF, 'onopen') && typeof __TF.onopen === 'function') this.onopen(__TF.onopen);
    if (Object.prototype.hasOwnProperty.call(__TF, 'onclose') && typeof __TF.onclose === 'function') this.onclose(__TF.onclose);
    if (Object.prototype.hasOwnProperty.call(__TF, 'onmessage') && typeof __TF.onmessage === 'function') this.onmessage(__TF.onmessage);
    if (Object.prototype.hasOwnProperty.call(__TF, 'autoLink')) this.autoLink = !!__TF.autoLink;
    if (Object.prototype.hasOwnProperty.call(__TF, 'auto') && __TF.auto) this.start();
  } else if (__TF === true) this.start();
  return this;
};

export default WSK;
